var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFemail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF8777",
    d: "M25.55 5.22a9.42 9.42 0 0 0-6.28-4.18A8.8 8.8 0 0 0 12.16 3a10.78 10.78 0 0 0-3.78 6.96c-.38 2.8.25 5.59 1.77 7.86a9.44 9.44 0 0 0 5.99 4.12v1.52h-3.5c-.86 0-1.56.77-1.56 1.72s.7 1.72 1.56 1.72h3.5v5.47c0 .94.7 1.72 1.55 1.72.86 0 1.56-.78 1.56-1.72V26.9h3.73c.86 0 1.56-.77 1.56-1.72s-.7-1.72-1.56-1.72h-3.73V22a9.03 9.03 0 0 0 4.3-1.96 10.78 10.78 0 0 0 3.77-6.95c.38-2.8-.25-5.6-1.77-7.87Zm-1.3 7.36a7.25 7.25 0 0 1-2.56 4.69 5.96 5.96 0 0 1-4.8 1.32 6.37 6.37 0 0 1-4.23-2.82 7.7 7.7 0 0 1-1.2-5.32A7.25 7.25 0 0 1 14 5.77a6.01 6.01 0 0 1 4.8-1.32 6.37 6.37 0 0 1 4.24 2.82 7.7 7.7 0 0 1 1.2 5.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#171717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M26.02 5.22A10.56 10.56 0 0 0 11.21 3a10.56 10.56 0 0 0-2.22 14.82 10.54 10.54 0 0 0 6.62 4.12v1.52h-3.87a1.73 1.73 0 0 0 0 3.44h3.87v5.47a1.73 1.73 0 0 0 3.45 0V26.9h4.12a1.73 1.73 0 0 0 0-3.44h-4.12V22a10.56 10.56 0 0 0 6.97-16.78h-.01Zm-1.45 7.36a7.13 7.13 0 0 1-8.13 6 7.13 7.13 0 0 1-6.01-8.13 7.13 7.13 0 0 1 8.13-6 7.13 7.13 0 0 1 6.01 8.13Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h35v35H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemail);
export default __webpack_public_path__ + "static/media/femail.f4dbd6bf45dc23220aa68d0592bd34ca.svg";
export { ForwardRef as ReactComponent };